import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { GeneralApiResponse } from '../core/models/general-api-response';
import { LineAssociation } from '../models/line-association.model';

interface ValidateSimByIccidProps {
  iccid: string;
  puk: string;
}

export interface GetDeviceByMsisdnResponse {
  imeiStatus: string;
  lastName: number;
  imeiDate: string;
  isOTASupported: string;
  imei: string;
  isImeiCheckCodeValid: string;
  model: string;
  certifiedEquipment: boolean;
  imsi: string;
  imeiStatusRegister: string;
  manufacturer: string;
  verificationCode: number;
}

export interface GetUserResponse {
  identityVerified: boolean;
  documentType: string;
  documentId: string;
  createdAt: string;
  attributes: Attributes;
  email: string;
  habeas: Habeas;
  name: string;
  channel: string;
  emailVerified: boolean;
  migrated: boolean;
  userId: string;
  updatedAt: string;
  id: string;
  type: string;
  lines: LineAssociation[];
}

export interface Attributes {
  lastName: string;
  address: Address;
  gender: any;
  document: Document;
  dateOfBirth: string;
  type: string;
  academicTitle: any;
  firstName: string;
  emailVerified: string;
  identity: Identity;
  identityVerified: boolean;
  personalTitle: any;
  maritalStatus: any;
  contacts: Contacts;
}

export interface Address {
  country: string;
  logistic: Logistic;
  city: string;
  postcode: string;
  state: string;
  line2: string;
  line1: string;
}

export interface Logistic {
  city: City;
  state: State;
}

export interface City {
  code: string;
  countryCode: string;
  departmentId: string;
  departmentCode: string;
  name: string;
  id: string;
  fullname: string;
  defaultProvider: string;
}

export interface State {
  name: string;
  id: string;
  fullname: string;
  code: string;
  countryCode: string;
  defaultProvider: string;
}

export interface Document {
  issueDate: string;
  expiryDate: string;
  expirationDate: any;
}

export interface Identity {
  documentType: string;
  verified: boolean;
  channel: string;
  documentId: string;
  verificationType: string;
  verificationDate: string;
  verificationAttemptDate: string;
}

export interface Contacts {
  alternatePhone: any;
  portalAccount: any;
  twitter: any;
  fax: any;
  phone: any;
  facebook: any;
}

export interface Habeas {
  date: any;
  disabled: boolean;
  status: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  private http = inject(HttpClient);

  private readonly API_BASE = environment.apiSecureUrl;

  constructor() {}

  validateSimByIccid(data: ValidateSimByIccidProps): Observable<GeneralApiResponse> {
    return this.http.post<GeneralApiResponse>(`${this.API_BASE}/validateSimByICCIDandPuk`, data);
  }

  getLineByIccid(iccid: string): Observable<GeneralApiResponse> {
    return this.http.get<GeneralApiResponse>(`${this.API_BASE}/line/iccid/${iccid}`);
  }

  getDeviceByMsisdn(msisdn: string): Observable<GeneralApiResponse<GetDeviceByMsisdnResponse>> {
    return this.http.get<GeneralApiResponse<GetDeviceByMsisdnResponse>>(
      `${this.API_BASE}/customer/line/device/msisdn/${msisdn}`
    );
  }

  getUser(email: string): Observable<GeneralApiResponse<GetUserResponse>> {
    const url = this.API_BASE.replace('/api/v1', '/api/v2/customer/user');
    return this.http.get<GeneralApiResponse<GetUserResponse>>(`${url}`);
  }
}
